export const CREWMEISTER_API_PREFIX = 'api.crewmeister';

export const ASYNC_RESOURCE_REQ_DELAY = 4000;
export const NUMBER_OF_RETRIES = 10;
